export class PreRegistrationModel {
    StudentNumber: string;
    GivenName: string;
    FamilyName: string;
    EmailAddress: string;
    DateOfBirth: string;
    CountryOfNationalityId: string;
    CountryOfResidenceId: string;
    WillStudyForYearOrLess: boolean;
    Parent1GivenName: string;
    Parent1FamilyName: string;
    Parent1Relationship: string;
    Parent2GivenName: string;
    Parent2FamilyName: string;
    Parent2Relationship: string;
    LegalCustodianGivenName?: string;
    LegalCustodianFamilyName?: string;
    IsGdprCompliant: boolean;

    StudentOnlyHasOneName: boolean;
    Parent1OnlyHasOneName: boolean;
    Parent2OnlyHasOneName: boolean;
    SingleParentOrGuardian: boolean;
}
